import en from './en.js'
import cn from './cn.js'
const messages = {
    en: {
        message:en
    },
    zhCH: {
        message:cn
    }
}
export default messages;